<div class="row d-flex justify-content-end container-style px-2 py-1">
  <div class="col-auto pt-1 pb-1">
    <app-custom-button [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'" [icon]="'pi pi-plus'"
      [width]="'5.5rem'" [variant]="undefined" (onClick)="createCostCenterPrice()"></app-custom-button>
    <app-custom-modal #costCenterPriceRegisterModal [label]="'Precios C.Costos - Captura'"
      [header]="'Precios C.Costos - Captura'" [inputs$]="inputsForRegisterModals$" [width]="'50rem'"
      [children]="componentRegisterModal" (params)="reloadList($event.reload)" [output$]="output$" hidden>
    </app-custom-modal>
  </div>
</div>
<div class="container-style mt-2" *ngIf="!isOpened">
  <app-custom-table [showImport]="true" [showExport]="true" [showRecover]="true" [headers]="costCenterHeader"
    [data]="costCenterData" [actions]="tableActions" [previousFilters]="filters"
    [filterPersistentKey]="'cost-center-price'" (onRecoverData)="getAllCostCenterPricesWithPagination()"
    (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)" (onImport)="onImport()"
    (onExport)="onExport()" (onAction)="onAction($event)" (onFilterChange)="onTableFilterChange($event)">
  </app-custom-table>
</div>
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1 text-danger"> highlight_off </span>
  <h6 class="text-danger">No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>
<app-custom-modal #costCenterPriceImportModal [label]="'Importar Precios por C.Costos'" [width]="'40rem'"
  [header]="'Importar Precios por C.Costos'" [children]="componentCostCenterPriceImportModal"
  (params)="reloadList($event.reload)" hidden>
</app-custom-modal>